import {
  applyContextOptions,
  restoreContextOptions,
} from "@gameApp/helpers/canvas/contextOptions";
import { drawTextPure } from "@gameApp/helpers/canvas/draw/textPure";
import {
  applyTranslate,
  restoreTranslate,
} from "@gameApp/helpers/canvas/translate";
import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";
import { isFunction } from "@gameApp/utils/isFunction";
import type { ScaleLinear } from "d3";

interface Params extends BasicDrawOptions {
  scale: ScaleLinear<number, number>;
  ticksCount: number;
  formatFn?: (d: number) => string;
  withStroke?: boolean;
}

export function miniGameChartsDrawYLabels(params: Params) {
  const { context, scale, ticksCount, contextOptions, withStroke, formatFn } =
    params;

  const yTicks = scale.ticks(ticksCount);

  const yTicksFormatted = yTicks.map((tick) => {
    return isFunction(formatFn) ? formatFn(tick) : tick;
  });

  applyTranslate(params);
  applyContextOptions(params);
  context.save();

  for (let i = 0; i < yTicks.length; i += 1) {
    const yTick = yTicks[i];
    const yTickFormatted = yTicksFormatted[i];

    drawTextPure({
      text: yTickFormatted,
      x: 0,
      y: scale(yTick),
      withStroke,
      context,
      contextOptions,
    });
  }

  context.restore();
  restoreContextOptions(params);
  restoreTranslate(params);
}
